var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNotesPet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_13470_30644)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64951 3.46484C2.82115 3.46484 2.14961 4.13631 2.14951 4.96466L2.14844 13.7847C2.14827 15.1655 3.26761 16.285 4.64844 16.285H12.3448C13.7255 16.285 14.8448 15.1657 14.8448 13.785V4.96484C14.8448 4.13642 14.1732 3.46484 13.3448 3.46484H3.64951ZM6.15872 8.11147C5.71689 8.11147 5.35872 8.46964 5.35872 8.91147C5.35872 9.3533 5.71689 9.71147 6.15872 9.71147H10.829C11.2708 9.71147 11.629 9.3533 11.629 8.91147C11.629 8.46964 11.2708 8.11147 10.829 8.11147H6.15872ZM6.15872 11.0284C5.71689 11.0284 5.35872 11.3866 5.35872 11.8284C5.35872 12.2702 5.71689 12.6284 6.15872 12.6284H10.829C11.2708 12.6284 11.629 12.2702 11.629 11.8284C11.629 11.3866 11.2708 11.0284 10.829 11.0284H6.15872Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 2.14062V4.51209",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 2.14062V4.51209",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13470_30644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNotesPet);
export default __webpack_public_path__ + "static/media/add-notes-pet.35cc7cb6.svg";
export { ForwardRef as ReactComponent };